import { Turnstile } from '@marsidev/react-turnstile'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import * as styles from './styles'

const CloudflareTurnstile = ({
  onSuccess,
  onError,
  action,
  error = false,
  resetError
}) => {
  const ref = useRef()

  const resetRecaptcha = () => {
    ref.current?.reset()
  }

  useEffect(() => {
    if (error) {
      resetRecaptcha()
      resetError()
    }
  }, [error])

  const renderTurnstile = () => {
    return (
      <Turnstile
        ref={ref}
        siteKey={process.env.CLOUDFLARE_TURNSTILE_KEY}
        onSuccess={(token) => onSuccess(token)}
        onError={onError}
        options={{
          theme: 'light',
          action,
          size: 'flexible'
        }}
      />
    )
  }

  return <div css={styles.container}>{renderTurnstile()}</div>
}

export default CloudflareTurnstile

CloudflareTurnstile.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  error: PropTypes.bool,
  resetError: PropTypes.func.isRequired
}
